import React from 'react';
import {Text} from '~/components/controls';
import PropTypes from 'prop-types';
const RentalClassText = ({
  style,
  rental_class,
  rental_classes,
  contract_rental_class = null,
  rental_car_class = null,
}) => (
  <>
    {rental_class ? (
      <Text style={style}>
        {rental_class}-
        {
          rental_classes?.find((item) => item.code === rental_class)
            ?.description
        }
        {(() => {
          if (
            rental_class === contract_rental_class &&
            rental_class === rental_car_class
          ) {
            return <>&nbsp;(contract&nbsp;&amp;&nbsp;inzet)</>;
          }
          if (rental_class === contract_rental_class) {
            return <>&nbsp;(contract)</>;
          }
          if (rental_class === rental_car_class) {
            return <>&nbsp;(inzet)</>;
          }
          return <></>;
        })()}
      </Text>
    ) : (
      <></>
    )}
  </>
);
RentalClassText.propTypes = {
  style: PropTypes.any,
  rental_class: PropTypes.any,
  rental_classes: PropTypes.any,
  contract_rental_class: PropTypes.any,
  rental_car_class: PropTypes.any,
};

export default RentalClassText;
